import { render } from "./CampaignDetailCard.vue?vue&type=template&id=5220740d&scoped=true&ts=true"
import script from "./CampaignDetailCard.vue?vue&type=script&lang=ts"
export * from "./CampaignDetailCard.vue?vue&type=script&lang=ts"

import "./CampaignDetailCard.vue?vue&type=style&index=0&id=5220740d&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5220740d"]])

export default __exports__